module.exports = __webpack_public_path__ + "img/social-ig.f09bcf81.png";